import React from 'react'
import styles from './styles.module.scss'

export default function EndpointSidebar() {

  return (
      <div className={styles.root}>
          {/*<p><strong>Endpoint menu</strong></p>
          <ul className={styles.menu}>
              <li>
                  <div className={styles.dataType}>
                      Menu
                  </div>
              </li>
          </ul>*/}
      </div>

  )

}
